<template>
  <div>
    <template>
      <div class="richmenu-head">
        <div class="text-center richmenu-head-text">News</div>
      </div>
      <div v-if="loading" class="text-center pt-12">
        <v-progress-circular
          indeterminate
          size="60"
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-else style="max-width: 500px" class="mx-auto">
        <!-- <div style="height: 60px; padding-top: 0px">
        <v-img
          style="margin-left: auto; margin-right: auto"
          width="80px"
          src="../../assets/depa.png"
        ></v-img>
      </div> -->
        <!-- <v-img :src="data.content_html"></v-img> -->
        <div class="mt-3">
          <div class="px-6">
            <h3
              style="color: rgb(12, 47, 83); font-size: 22px; line-height: 27px"
            >
              {{ data.title }}
            </h3>
            <div class="newsimg mt-4" v-html="data.content_html"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: false,
      data: {},
    };
  },
  async mounted() {
    this.loading = true;
    await this.depanewsById();

    this.loading = false;
  },
  methods: {
    depanewsById() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "depanewsById", {
            params: {
              new_id: this.query.new_id,
            },
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.data = response.data.data[0];
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
            resolve();
          });
      });
    },
  },
};
</script>

<style lang="scss">
.newsimg img {
  width: 100% !important;
}
</style>